import axios from "axios";
import { BASEURL } from "../../baseUrl";
import { toast } from "react-toastify";
import { appointmentAllCount, doctorAppointmentAllCount } from "./Admin.action";
import { allDoctorAppointment } from "./Doctor.action";

export const CREATE_LEAD = 'CREATE_LEAD';
export const GET_ALL_LEAD = 'GET_ALL_LEAD';
export const UPDATE_LEAD = 'UPDATE_LEAD';
export const DELETE_LEAD = 'DELETE_LEAD';
export const VERIFY_OTP = 'VERIFY_OTP';
export const SEARCH_LEAD = 'SEARCH_LEAD';
export const VIEW_LEAD = 'VIEW_LEAD';
export const ADD_APPOINTMENT = 'ADD_APPOINTMENT';
export const GET_APPOINTMENT = 'GET_APPOINTMENT';
export const GET_APPOINTMENT_ID = 'GET_APPOINTMENT_ID';
export const CONFIRM_APPOINTMENT = 'CONFIRM_APPOINTMENT';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const DELETE_APPOINTMENT = 'DELETE_APPOINTMENT';
export const DELETE_APPOINTMENT_OTP = 'DELETE_APPOINTMENT_OTP';
export const COUNT_APPOINTMENT = 'COUNT_APPOINTMENT';
export const SLIP_APPOINTMENT = 'SLIP_APPOINTMENT';
export const ALL_PATIENT = 'ALL_PATIENT';
export const ALL_PATIENT_SEARCH = 'ALL_PATIENT_SEARCH';
export const ALL_BRANCH = 'ALL_BRANCH'
export const ALL_PROBLEM = 'ALL_PROBLEM'
export const ALL_DOCTOR = 'ALL_DOCTOR'
export const ALL_DOCTOR_SEARCH = 'ALL_DOCTOR_SEARCH'
export const ALL_PROBLEM_SEARCH = 'ALL_PROBLEM_SEARCH'
export const ALL_APPOINTMENT = 'ALL_APPOINTMENT'
export const EXPORT_APPOINTMENT = 'EXPORT_APPOINTMENT'
export const ALL_COUNSELOR = 'ALL_COUNSELOR'
export const SEARCH_ALL_COUNSELOR = 'SEARCH_ALL_COUNSELOR'
export const SEARCH_APPOINTMENT = 'SEARCH_APPOINTMENT'
export const SEARCH_ALL_APPOINTMENT = 'SEARCH_ALL_APPOINTMENT'
export const GET_FOLLOWUP = 'GET_FOLLOWUP'
export const GET_NEXT_FOLLOWUP = 'GET_NEXT_FOLLOWUP'
export const ADD_BULK_DATA = 'ADD_BULK_DATA'
export const GET_PATIENT_EXCEL = 'GET_PATIENT_EXCEL'

const leadCreateAction = (payload) => ({ type: CREATE_LEAD, payload: payload });
const leadGetAction = (payload) => ({ type: GET_ALL_LEAD, payload: payload });
const leadUpdateAction = (payload) => ({ type: UPDATE_LEAD, payload: payload });
const leadDeleteAction = (payload) => ({ type: DELETE_LEAD, payload: payload });
const verifyOtpAction = (payload) => ({ type: VERIFY_OTP, payload: payload });
const leadSearchAction = (payload) => ({ type: SEARCH_LEAD, payload: payload });
const leadViewAction = (payload) => ({ type: VIEW_LEAD, payload: payload });
const appointmentAddAction = (payload) => ({ type: ADD_APPOINTMENT, payload: payload });
const appointmentGetAction = (payload) => ({ type: GET_APPOINTMENT, payload: payload });
const appointmentGetByIdAction = (payload) => ({ type: GET_APPOINTMENT_ID, payload: payload });
const appointmentConfirmAction = (payload) => ({ type: CONFIRM_APPOINTMENT, payload: payload });
const appointmentUpdateAction = (payload) => ({ type: UPDATE_APPOINTMENT, payload: payload });
const appointmentDeleteAction = (payload) => ({ type: DELETE_APPOINTMENT, payload: payload });
const appointmentOtpVerifyAction = (payload) => ({ type: DELETE_APPOINTMENT_OTP, payload: payload });
const appointmentCountAction = (payload) => ({ type: COUNT_APPOINTMENT, payload: payload });
const appointmentSlipAction = (payload) => ({ type: SLIP_APPOINTMENT, payload: payload });
const allPatientpAction = (payload) => ({ type: ALL_PATIENT, payload: payload });
const allPatientSearchpAction = (payload) => ({ type: ALL_PATIENT_SEARCH, payload: payload });
const allBranchAction = (payload) => ({ type: ALL_BRANCH, payload: payload });
const allproblemAction = (payload) => ({ type: ALL_PROBLEM, payload: payload });
const allDoctorAction = (payload) => ({ type: ALL_DOCTOR, payload: payload });
const allDoctorSearchAction = (payload) => ({ type: ALL_DOCTOR_SEARCH, payload: payload });
const allProblemSearchAction = (payload) => ({ type: ALL_PROBLEM_SEARCH, payload: payload });
const allAppointmentAction = (payload) => ({ type: ALL_APPOINTMENT, payload: payload });
const exportAppointmentAction = (payload) => ({ type: EXPORT_APPOINTMENT, payload: payload });
const allCounselorAction = (payload) => ({ type: ALL_COUNSELOR, payload: payload });
const searchallCounselorAction = (payload) => ({ type: SEARCH_ALL_COUNSELOR, payload: payload });
const searchAppointmentAction = (payload) => ({ type: SEARCH_APPOINTMENT, payload: payload });
const searchAllAppointmentAction = (payload) => ({ type: SEARCH_ALL_APPOINTMENT, payload: payload });
const getFollowupAction = (payload) => ({ type: GET_FOLLOWUP, payload: payload });
const getNextFollowupAction = (payload) => ({ type: GET_NEXT_FOLLOWUP, payload: payload });
const addBulkDataAction = (payload) => ({ type: ADD_BULK_DATA, payload: payload });
const getPatientExcelAction = (payload) => ({ type: GET_PATIENT_EXCEL, payload: payload });

export const leadCreate = (payload, limits, status) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/receptionist/registerPatient`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Lead Create successfully')
                dispatch(leadCreateAction(res));
                dispatch(leadGet(limits, status))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(leadCreateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const leadGet = (payload, status) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/getAllPatient?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(leadGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(leadGetAction(error?.response));
            });
        } catch (error) {
            console.log('Error login user:', error);
        }
    }
}

export const updateLead = (payload, limits, status, queryParams) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/receptionist/upadtePatient`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Update Lead successfully')
                dispatch(leadUpdateAction(res));
                dispatch(leadGet(limits, status))
                dispatch(getFollowup(queryParams))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(leadUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteLead = (payload, limits, status) => {
    return async (dispatch) => {
        try {
            // const { patientIds } = payload;
            // const cleanedIds = patientIds.flat();
            await axios.post(`${BASEURL}/receptionist/verifyotp`, payload).then(((res) => {
                toast.success('Delete Lead successfully')
                dispatch(leadDeleteAction(res));
                dispatch(leadGet(limits, status))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(leadDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const searchLead = (queryParams) => {

    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/searchPatient?${queryParams}`).then(((res) => {
                dispatch(leadSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(leadSearchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const verifyOtp = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/receptionist/deletePatient`, payload).then(((res) => {
                toast.success('Send Otp to Master successfully')
                dispatch(verifyOtpAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(verifyOtpAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewLead = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/getPatientById/${id}`).then(((res) => {
                dispatch(leadViewAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(leadViewAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const appointementCreate = (payload, currentDate, limits, data) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/appointment/addAppointment`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Appointement Create successfully')
                dispatch(appointmentAddAction(res));
                dispatch(appointementGet(currentDate, limits))
                dispatch(countAppointment(data))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(appointmentAddAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const appointementGet = (currentDate, limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/appointment/getAllAppointments?date=${currentDate}&page=${limits.page}&limit=${limits.limit}`).then(((res) => {
                dispatch(appointmentGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(appointmentGetAction(error?.response));
            });
        } catch (error) {
            console.log('Error login user:', error);
        }
    }
}

export const appointementGetById = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/appointment/getAppointmentById/${id}`,).then(((res) => {
                dispatch(appointmentGetByIdAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(appointmentGetByIdAction(error?.response));
            });
        } catch (error) {
            console.log('Error login user:', error);
        }
    }
}

export const appointementConfirm = (id, data, currentDate, limits) => {
    return async (dispatch) => {
        try {
            // Include the data if needed, else you can remove it
            await axios.put(`${BASEURL}/appointment/confirmAppointment/${id}`)
                .then((res) => {
                    dispatch(appointmentConfirmAction(res.data)); // Ensure you're dispatching the correct data

                    // Dispatch all follow-up actions
                    return Promise.all([
                        dispatch(countAppointment(data)),
                        dispatch(appointementGet(currentDate, limits)),
                        dispatch(allAppointmentDetail(limits)),
                        dispatch(appointmentAllCount()),
                        dispatch(allDoctorAppointment(limits)),
                        dispatch(doctorAppointmentAllCount())
                    ]);
                })
                .then(() => {
                    toast.success('Appointment Confirmed successfully');
                })
                .catch((error) => {
                    console.log("Error", error);
                    toast.error(error?.response?.data?.message || "Error confirming appointment");
                    dispatch(appointmentConfirmAction(error?.response));
                });
        } catch (error) {
            console.log('Error confirming appointment:', error);
            toast.error("Error confirming appointment");
        }
    }
}


export const appointementUpdate = (id, payload, currentDate, limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/appointment/updateAppointment/${id}`, payload).then(((res) => {
                toast.success('Update Appointment successfully')
                dispatch(appointmentUpdateAction(res));
                dispatch(appointementGet(currentDate, limits))
                dispatch(allAppointmentDetail(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(appointmentUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteAppointmentOtp = (payload, currentDate, limits) => {

    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/appointment/verifyDeleteotp`, payload).then(((res) => {
                toast.success('Delete Appointment Successfully')
                dispatch(appointmentOtpVerifyAction(res));
                dispatch(appointementGet(currentDate, limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(appointmentOtpVerifyAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteAppointment = (deleteId) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/appointment/deleteAppointment/${deleteId}`).then(((res) => {
                toast.success('Otp Send to Master Successfully')
                dispatch(appointmentDeleteAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(appointmentDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const countAppointment = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/appointment/countappointments`, payload).then(((res) => {
                dispatch(appointmentCountAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(appointmentCountAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const slipAppointment = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/appointment/genrateSlip/${id}`).then(((res) => {
                dispatch(appointmentSlipAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(appointmentSlipAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const patientData = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/getAllPatientForDropDown`).then(((res) => {
                dispatch(allPatientpAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allPatientpAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const patientSearchData = (params) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/searchPatientForDropDown?search=${params}`).then(((res) => {
                dispatch(allPatientSearchpAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allPatientSearchpAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}
export const allBranchDetail = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/dropDownGetAllBranches`).then(((res) => {
                dispatch(allBranchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allBranchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const allProblemDetail = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/dropDownGetAllProblem`).then(((res) => {
                dispatch(allproblemAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allproblemAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const allDoctorDetail = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllDoctorForDropDown`).then(((res) => {
                dispatch(allDoctorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allDoctorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const allDoctorSearchDetail = (params) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchDoctorForDropDown?search=${params}`).then(((res) => {
                dispatch(allDoctorSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allDoctorSearchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const allProblemSearchDetail = (params) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchProblemForDropDown?search=${params}`).then(((res) => {
                dispatch(allProblemSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allProblemSearchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const allAppointmentDetail = (params, startDate, type) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/appointment/getAllAppointment?page=${params.page}&limit=${params.limit}&date=${startDate}&status=${type}`).then(((res) => {
                dispatch(allAppointmentAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allAppointmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const exportAppointmentDetail = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/getAllPatientExport`).then(((res) => {
                dispatch(exportAppointmentAction(res));
                toast.success('Patient Data Export Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                dispatch(exportAppointmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const allCounselorDetail = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/auth/getRegisteredCounselor`).then(((res) => {
                dispatch(allCounselorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allCounselorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const searchAllCounselorDetail = (params) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/auth/searchCounselorsByName?search=${params.search}`).then(((res) => {
                dispatch(searchallCounselorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchallCounselorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const searchAppointmentDetail = (queryParams,issue) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/appointment/datewiseSearch?${queryParams}&issue=${issue}`).then(((res) => {
                dispatch(searchAppointmentAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchAppointmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const searchAllAppointmentDetail = (queryParams,issue) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/appointment/searchAppointmentWithoutDate?page=${queryParams.page}&limit=${queryParams.limit}&searchQuery=${queryParams.search}&issue=${issue}`).then(((res) => {
                dispatch(searchAllAppointmentAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchAllAppointmentAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getFollowup = (queryParams) => {
    console.log('queryParamsqueryParams', queryParams);

    return async (dispatch) => {
        try {
            if (queryParams?.date) {
                await axios.get(`${BASEURL}/receptionist/dateWiseFollowupDate?page=${queryParams.page}&limit=${queryParams.limit}&date=${queryParams.date}&searchQuery=${queryParams.search}`).then(((res) => {
                    dispatch(getFollowupAction(res));
                })).catch((error) => {
                    console.log("Error", error);
                    dispatch(getFollowupAction(error?.response));
                });
            } else {
                await axios.get(`${BASEURL}/receptionist/dateWiseFollowupDate?page=${queryParams.page}&limit=${queryParams.limit}&searchQuery=${queryParams.search}`).then(((res) => {
                    dispatch(getFollowupAction(res));
                })).catch((error) => {
                    console.log("Error", error);
                    dispatch(getFollowupAction(error?.response));
                });
            }
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getNextFollowup = () => {

    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/getAllFollowupDate`).then(((res) => {
                dispatch(getNextFollowupAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getNextFollowupAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addBulkData = (payload, limits, status) => {

    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/receptionist/uploadBulkPatientData`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(addBulkDataAction(res));
                dispatch(leadGet(limits, status))
                toast.success('Add Data Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addBulkDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getPatientExcelData = (queryParams) => {
    return async (dispatch) => {
        try {
            const queryString = new URLSearchParams(queryParams).toString();
            await axios.get(`${BASEURL}/receptionist/searchPatientExport?${queryString}`).then(((res) => {
                dispatch(getPatientExcelAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getPatientExcelAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}